export default {
  noTransactions: '目前沒有找到支援代幣的鏈上交易。', tokenSwap: '代幣交換', receivedToken: '收到代幣', sentToken: '發送代幣', transactionHash: '交易哈希', unknownToken: '未知代幣', loadMore: '載入更多紀錄', loadingMore: '正在載入另外 30 筆紀錄…', pullUpToLoad: '向上拉載入更多紀錄', noMoreRecords: '沒有更多紀錄',
  confirmed: '已確認', swapSent: '發送', swapReceived: '收到',
  onChainRecords: '鏈上紀錄',
  connectMetaMaskDescription: '連接 MetaMask 後，這裡會顯示 MetaMask 的支援代幣交易紀錄。',
  loggedInDescription: '登入或連接 World App 後，這裡會顯示支援代幣交易紀錄。', loadingRecords: '正在讀取鏈上紀錄…',
  selectTransactionWallet: '選擇交易紀錄錢包',
  bubbleWallet: {
    title: '遊戲紀錄',
    loginRequired: '登入後查看 Bubble Game 消費和 Bubble Wallet 操作紀錄。',
    loading: '正在讀取 Bubble Wallet 活動…',
    loadMore: '載入更多',
    loadingMore: '正在載入更多…',
    noRecords: '目前沒有 Bubble Game 消費或 Bubble Wallet 操作紀錄。',
    recorded: '已記錄',
    types: {
      shop_purchase_bbg: '使用 BBG 購買裝備',
      gacha_bbg: '抽取新角色',
      furnace_bbt: 'BBT 熔爐',
      skin_purchase: '購買皮膚',
      character_synthesis_bbg: '合成角色',
      throne_challenge_bbg: 'BBG 王座挑戰',
      claim_bbg: 'Claim BBG',
      swap: '代幣 Swap',
      send: 'Send 代幣',
    },
    statuses: {
      completed: '已完成',
      failed: '失敗',
      pending: '處理中',
      unknown: '已記錄',
    },
  },
} as const;
